import { render, staticRenderFns } from "./v-button.vue?vue&type=template&id=6a9a13dc&scoped=true&"
import script from "./v-button.vue?vue&type=script&lang=ts&"
export * from "./v-button.vue?vue&type=script&lang=ts&"
import style0 from "./v-button.vue?vue&type=style&index=0&id=6a9a13dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9a13dc",
  null
  
)

export default component.exports